import htmx from 'htmx.org';

const onLoad = <E extends Element = Element>(selectors: string, handler: ($item: E) => void) => {
  document.querySelectorAll<E>(selectors).forEach(handler);

  htmx.on('htmx:afterSwap', ({ target }) => {
    if (target instanceof HTMLElement) {
      target.querySelectorAll<E>(selectors).forEach(handler);
    }
  });

  window.addEventListener('rerendered', ({ target }) => {
    if (target instanceof Element) {
      target.querySelectorAll<E>(selectors).forEach(handler);
    }
  });
};

export default onLoad;
